import { render } from "./InstructionsTabs.vue?vue&type=template&id=0694f008&ts=true"
import script from "./InstructionsTabs.vue?vue&type=script&lang=ts"
export * from "./InstructionsTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__